import { getTHERMSImageThumbnailUrl } from "../../Files/utils/get-therms-image-thumbnail-url.js";
import { useAppInteractionHandlers } from "../../AppWrapper2/hooks/useAppInteractionHandlers.js";
import { useUsers } from "../hooks/useUsers.js";
import "react";
import { Avatar, Card, Skeleton } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
import classnames from "classnames";
//#region src/modules/Users/shared/UserCard.tsx
var UserCard = ({ onClick, userId }) => {
	const appInteractionHandlers = useAppInteractionHandlers();
	const isClickable = Boolean(onClick || appInteractionHandlers?.onClickUser);
	const { data, loading } = useUsers(userId && { idFilter: [userId] });
	if (!data?.users && loading) return /* @__PURE__ */ jsx(Card, {
		className: "bg-surface-subtle relative overflow-hidden",
		children: /* @__PURE__ */ jsxs("div", {
			className: "space-sm flex",
			children: [/* @__PURE__ */ jsx(Skeleton.Circle, {}), /* @__PURE__ */ jsxs("div", {
				className: "space-y-xs flex flex-1 flex-col",
				children: [/* @__PURE__ */ jsx(Skeleton.Text, {}), /* @__PURE__ */ jsx(Skeleton.Text, {})]
			})]
		})
	});
	if (!userId?.length || !data?.users) return null;
	const user = data.users[0];
	const isInactive = !user.active;
	const isClickableForUser = isClickable && !isInactive;
	return /* @__PURE__ */ jsxs(Card, {
		className: classnames("bg-surface-subtle relative overflow-hidden", { "cursor-pointer": isClickableForUser }),
		onClick: isClickableForUser ? () => {
			if (onClick) onClick(userId);
			else if (appInteractionHandlers?.onClickUser) appInteractionHandlers.onClickUser(userId);
		} : void 0,
		space: "xxs",
		padding: "xs",
		children: [/* @__PURE__ */ jsxs("div", {
			className: classnames({ "opacity-50": isInactive }, "gap-x-xs inline-flex items-center"),
			children: [/* @__PURE__ */ jsx(Avatar, {
				circular: true,
				url: getTHERMSImageThumbnailUrl(user.avatarUrl),
				size: "xxs"
			}), /* @__PURE__ */ jsxs("div", {
				className: "flex flex-1 flex-col",
				children: [/* @__PURE__ */ jsx("span", { children: user.displayName }), user.title && /* @__PURE__ */ jsx("span", {
					className: "text-neutral text-sm font-medium",
					children: user.title
				})]
			})]
		}), isInactive && /* @__PURE__ */ jsx("div", {
			className: "z-sticky bg-critical/10 text-color-critical p-sm absolute inset-0 flex items-center justify-center rounded font-bold tracking-wider",
			children: "INACTIVE"
		})]
	});
};
//#endregion
export { UserCard };

//# sourceMappingURL=UserCard.js.map